var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImageClub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5817_48058)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F9FAF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7281 24.3076C15.817 24.3225 15.9076 24.3299 15.9999 24.3299C16.0922 24.3299 16.1828 24.3225 16.2717 24.3076C16.3606 24.2928 16.4466 24.2706 16.5298 24.241C18.4044 23.5743 19.8959 22.3923 21.0041 20.6948C22.1124 18.9974 22.6665 17.1658 22.6665 15.2V11.1966C22.6665 10.8604 22.5691 10.557 22.3742 10.2863C22.1794 10.0157 21.9286 9.81936 21.6221 9.69744L16.5623 7.80855C16.372 7.74018 16.1845 7.70599 15.9999 7.70599C15.8153 7.70599 15.6278 7.74018 15.4375 7.80855L10.3777 9.69744C10.0711 9.81936 9.82044 10.0157 9.62556 10.2863C9.43069 10.557 9.33325 10.8604 9.33325 11.1966V15.2C9.33325 17.1658 9.88739 18.9974 10.9957 20.6948C12.1039 22.3923 13.5953 23.5743 15.47 24.241C15.5532 24.2706 15.6392 24.2928 15.7281 24.3076ZM19.8221 20.0889C18.8147 21.5555 17.5406 22.5333 15.9999 23.0222C14.4592 22.5333 13.1851 21.5555 12.1777 20.0889C11.1703 18.6222 10.6666 16.9926 10.6666 15.2V13.8127L20.784 18.2644C20.5428 18.8983 20.2222 19.5064 19.8221 20.0889ZM21.1584 16.9725L10.6666 12.356V11.188C10.6666 11.131 10.6822 11.0798 10.7136 11.0342C10.7449 10.9886 10.7891 10.9544 10.8461 10.9316L15.9059 9.0427C15.9344 9.03131 15.9657 9.02562 15.9999 9.02562C16.0341 9.02562 16.0654 9.03131 16.0939 9.0427L21.1537 10.9316C21.2107 10.9544 21.2549 10.9886 21.2862 11.0342C21.3176 11.0798 21.3332 11.131 21.3332 11.188V15.2C21.3332 15.8096 21.275 16.4005 21.1584 16.9725Z",
    fill: "#7C7D79"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#111111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5817_48058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageClub);
export default __webpack_public_path__ + "static/media/noImageClub.c1273502e3d69d4ca23e23df30105462.svg";
export { ForwardRef as ReactComponent };